if (!global.test) {
    var swal = require('bootstrap-sweetalert');
    swal.setDefaults({ animation: false });
}

var constants = require('./constants');
var filekeyHelpers = require('./filekey-helpers');
var awsConstants = constants.awsConstants;
var groupBy = require('./group-by');
var availableLocales = constants.serverConstants.availableLocales;

module.exports = function (bucket, firmware, skipFileExists, fromDashboard) {
    var datePublished = new Date().toUTCString();
    firmware.date = datePublished;
    var initPromise = Promise.resolve(null);
    if (!skipFileExists) {
        initPromise = initPromise.then(function () {
            return checkPublishedFileExists(bucket, firmware)
                .catch(function (error) {
                    if (error.code === 'NotFound') {
                        return false;
                    } else {
                        throw error;
                    }
                })
                .then(function (publishedFileExists) {
                    console.log('published file exists');
                    console.log(publishedFileExists);
                    if (publishedFileExists) {
                        return new Promise(function (resolve, reject) {
                            swal({
                                title: 'Are you sure?',
                                text: 'Published firmware for this model and version already exists. Are you sure you want to replace the file??',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonClass: 'btn-default',
                                confirmButtonText: 'Replace File',
                                closeOnConfirm: true
                            }, function (isConfirm) {
                                if (isConfirm) {
                                    resolve();
                                } else {
                                    reject('cancelled');
                                }
                            });
                        });
                    }
                });
        });
    }
    return initPromise
        // look for matching release notes, move to release_notes.json (or remove existing file if not found)
        .then(function () {
            return uploadReleaseNotes(bucket, firmware);
        })
        .then(function () {
            return updateInfoFileJSON(bucket, firmware, fromDashboard);
        })
        .then(function (infoJSON) {
            var mergedLog = Object.assign({}, infoJSON)
            mergedLog.releaseNotes = firmware.releaseNotes
            mergedLog.username = firmware.username
            return updatePublishLogJSON(bucket, mergedLog);
        })
        .then(function () {
            return firmware;
        });
};



function updatePublishLogJSON(bucket, firmware) {
    var publishLogKey = filekeyHelpers.generatePublishLogKey(firmware.model, firmware.version);
    var updateParams = {
        Bucket: bucket,
        Key: publishLogKey,
        Body: JSON.stringify(firmware),
        ContentType: 'application/json'
    };
    return window.s3.putObject(updateParams).promise();
}

function updateInfoFileJSON(bucket, firmware, fromDashboard) {
    var infoFileKey = filekeyHelpers.generateInformationFileKey(firmware.model);
    var content = {
        model: firmware.model,
        version: firmware.version,
        firmware: firmware.firmware,
        firmware_version: firmware.version,
        date: firmware.date,
        firmware_name: firmware.firmware_name
    };

    return resourceFile1Exists(bucket, firmware.firmware_name)
        .then(function (res) {
            if (res) {
                var resource1Key = filekeyHelpers.generateResourceFile1Key(firmware.firmware_name);
                content.resource1 = resource1Key;
                content.resource1_version = firmware.version;

                if (fromDashboard) {
                    var resource2KeysArray = Object.keys(firmware).filter(function (item) {
                        return item.indexOf('resource2') > -1
                    });
                    var containsResource2Key =  resource2KeysArray.length > 0
                    if (containsResource2Key) {
                        // copy existing resource2 keys as this is from last publish log
                        resource2KeysArray.forEach(function (key) {
                            content[key] = firmware[key]
                        });
                    } else {
                        // else fall back to latest locales
                        var resource2List = JSON.parse(localStorage.getItem('resource2-list'));
                        updateContentWithLatestLocales(resource2List, content) 
                    }
                } else {
                    // logic from publish firmware tab
                    if (!firmware.resource2Versions) {
                        var resource2List = JSON.parse(localStorage.getItem('resource2-list'));
                        updateContentWithLatestLocales(resource2List, content)        
                    } else {
                        updateContentWithLatestLocales(firmware.resource2Versions, content)        
                    }
                }
            };

            console.log('about to publish content');
            console.log(content);

            var updateParams = {
                Bucket: bucket,
                Key: infoFileKey,
                Body: JSON.stringify(content),
                ContentType: 'application/json'
            };
            return window.s3.putObject(updateParams).promise().then(function() {
                return content
            });
        });
}

function updateContentWithLatestLocales(resource2List, content) {
    var resource2ByLocale = groupBy(resource2List, 'locale');
    Object.keys(resource2ByLocale).forEach(function (locale) {
        if (availableLocales.indexOf(locale) !== -1) {
            var latestLocalMetadata = resource2ByLocale[locale].sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
            })[0];
            var latestLocaleFileKey = filekeyHelpers.generateResourceFile2Key(latestLocalMetadata.locale, latestLocalMetadata.checksum, latestLocalMetadata.version);
            content['resource2_' + locale] = latestLocaleFileKey;
        }
    });
}

function resourceFile1Exists(bucket, firmwareName) {
    var resource1Key = filekeyHelpers.generateResourceFile1Key(firmwareName);
    var params = {
        Bucket: bucket,
        Key: resource1Key
    };
    return window.s3.headObject(params).promise()
        .catch(function (error) {
            console.log(error.code);
            if (error.code === 'NotFound') {
                return false;
            } else {
                throw error;
            }
        });
}

function uploadReleaseNotes(bucket, firmware) {
    var releaseNotesFileKey = filekeyHelpers.generateReleaseNotesFileKey(firmware.model);
    var releaseNotesJSON = {};
    releaseNotesJSON[firmware.version] = firmware.releaseNotes;
    var releaseNotesFileParams = {
        Bucket: bucket,
        Key: releaseNotesFileKey,
        ContentType: 'application/json',
        Body: JSON.stringify(releaseNotesJSON),
        Metadata: {
            version: firmware.version,
            model: firmware.model,
            username: firmware.username
        }
    };
    return window.s3.putObject(releaseNotesFileParams).promise();
}

function checkPublishedFileExists(bucket, firmware) {
    var key = filekeyHelpers.generatePublishLogKey(firmware.model, firmware.version);
    var params = {
        Bucket: bucket,
        Key: key
    };
    // will error in catch if firmware doesnt exist
    return window.s3.headObject(params).promise();
}
